import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=06a619e2&scoped=true"
import script from "./VerticalMenu.vue?vue&type=script&lang=js"
export * from "./VerticalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a619e2",
  null
  
)

export default component.exports